import React from 'react'
import Numeral from 'numeral'
import { Bar } from 'recharts'

import transform from 'containers/inventory/details/resource/charts/transform'
import colors from 'lib/colors'
import Empty from 'components/charts/empty'
import ChartContainer from 'components/charts/container'
import { ERRORS } from 'containers/inventory/details/resource/metrics-tabs/services/elb-application-load-balancer'

const ELBRequestsChart = ({ loading, data, height, span }) => {
  if (loading || !data) return null

  const metrics = transform({
    '4xx': data.ELB_LOADBALANCER_TARGETS_RESPONSE_CODE_4XX,
    [ERRORS]: data.ELB_LOADBALANCER_TARGETS_RESPONSE_CODE_5XX
  })

  if (!metrics.length) return <Empty height={height} />

  const tooltipFormatter = (value, name, props) => {
    return [Numeral(value).format('0.[0]a'), undefined]
  }

  return (
    <ChartContainer height={height}
      data={metrics}
      yTicksFormatting='0 a'
      span={span}
      tabKey={ERRORS}
      formatTab={value => `${Numeral(value).format('0.[0]a')}`}
      formatTooltip={tooltipFormatter}
    >
      <Bar dataKey='4xx' stackId='a' fill={colors('chart', 'yellowLight')} name='4XX' barSize={4} />
      <Bar dataKey={ERRORS} stackId='a' fill={colors('chart', 'red')} name='5XX' barSize={4} />
    </ChartContainer>
  )
}

export default ELBRequestsChart
